<template>
    <div v-if="debugMode"
            :key="field.id" 
            :style="{ gridRow: field.row, gridColumn: `${field.column} / span ${field.size}`}"
            :data-field-id="field.id"
            draggable="true"
           
            @dragover="handleDragOver($event, field)"   
            @dragleave="handleDragLeave($event, field)"
            @drop="handleDrop($event, field)"

            @dragstart="handleDragStart($event, field)"
            @dragend="handleDragEnd($event, field)"

            class="draggable-field"
            :class="{ 
                'drag-over': field.isDragOver,
                'drop-before': field.dropPosition === DROP_POSITION.BEFORE,
                'drop-after': field.dropPosition === DROP_POSITION.AFTER,
                'drop-up': field.dropPosition === DROP_POSITION.UP,
                'drop-down': field.dropPosition === DROP_POSITION.DOWN
            }"
        >
        <div>
            <div class="field-position-info">
                    <span class="position-badge row-badge">R:{{ field.row }}</span>
                    <span class="position-badge column-badge">C:{{ field.column }}</span>
                    <span class="position-badge order-badge">T:{{ field.size }}</span>
            </div>
            <slot></slot>
            <div 
                class="resize-handle"
                @mousedown="startResize($event, field)"
                @touchstart="startResize($event, field)"
                title="Redimensionar campo"
            >
             <span class="resize-icon">↘</span>
            </div>

        </div>
    </div>
    <div v-else :style="{ gridRow: field.row, gridColumn: `${field.column} / span ${field.size}`}"    >
        <slot></slot>
    </div>
</template>

<script>
import DROP_POSITION from '../enum/FormDesign';

export default {
    name: 'DropField',
    data() {
        return {
            DROP_POSITION
        }
    },
    props: {
        field: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: false
        },
        debugMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {

        handleDragStart(event, field) {
            console.log('handleDragStart internal', field.name); 
            // Guardar el campo que se está arrastrando
            event.dataTransfer.setData('text/plain', field.id);
            event.dataTransfer.effectAllowed = 'move';
            
            // Agregar clase visual para el elemento que se arrastra
            event.target.style.opacity = '0.5';
        },
        handleDragEnd(event, field) {
            console.log('handleDragEnd internal', field.name);
            if (event.target) {
                event.target.style.opacity = '';
            }
            field.isDragOver = false;
            field.dropPosition = null;
            field.isSelected = false;
        },
        handleDragLeave(event, field) {
            console.log('handleDragLeave internal', field.name);
            field.isDragOver = false;
            field.dropPosition = null;
            field.isSelected = false;
            this.$emit('field-dragleave', event, field);
        },
        /*
        handleDragOver(event, field) {
            console.log('handleDragOver internal', field.name);
    
        },*/
        handleDragOver(event, field) {
            // Permitir el drop

            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';

            const fieldElement = event.target.closest('.draggable-field');

            if (fieldElement) {
                const fieldId = fieldElement.getAttribute('data-field-id');

                console.log('handleDragOver', fieldId);

                // Determinar la posición del drop basada en la posición del cursor
                const rect = fieldElement.getBoundingClientRect();
                const cursorX = event.clientX;
                const cursorY = event.clientY;
                //  const fieldCenterX = rect.left + rect.width / 4;
                  const fieldCenterY = rect.top + rect.height / 2;
                    

              const toleranceX = rect.width / 4
              const toleranceY = 20

                field.dropPosition = null;
                field.isDragOver = true;  
                  
                        
                if (Math.abs(cursorX - rect.left) < toleranceX && Math.abs(cursorY - fieldCenterY) < toleranceY) {
                    field.dropPosition = DROP_POSITION.BEFORE;
                    field.isDragOver = true;
                
                } 

                if (Math.abs(cursorX - (rect.left + rect.width)) < toleranceX) {
                    field.dropPosition = DROP_POSITION.AFTER;
                    field.isDragOver = true;                
                }

                if (Math.abs(cursorY - rect.top) < toleranceY) {
                    field.dropPosition = DROP_POSITION.UP;    
                    field.isDragOver = true;
                }
                if (Math.abs(cursorY - (rect.top + rect.height)) < toleranceY) {
                    field.dropPosition = DROP_POSITION.DOWN;
                    field.isDragOver = true;
                }

                                      
            }

            this.$emit('field-dragover', event);
        },
        handleDrop(event, field) {
            console.log('handleDrop internal', field.name);
            this.$emit('field-drop', event, field);
        },  /*    
        handleDragEnd(event) {
            this.$emit('dragend', event);
        },*/
        startResize(event, field) {
            this.$emit('field-startresize', event, field);
        },
    }
}
</script>

<style scoped>

* {
  --border-width: 8px;
}

/* Estilos para los badges de posición */
.field-position-info {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  gap: 3px;
  z-index: 10;
  pointer-events: none;
  height: 20px;
}

.position-badge {
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 500;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.1);
  opacity: 0.7;
  transition: all 0.3s ease;
}

.row-badge {
  color: #d35400;
}

.column-badge {
  color: #2980b9;
}

.order-badge {
  color: #27ae60;
}

/* Hover effects para los badges */
.position-badge:hover {
  opacity: 1;
  transform: scale(1.05);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* Estilos para drag and drop */
.draggable-field {
  transition: all 0.3s ease;
  cursor: grab;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 8px;
  padding-top: 30px;
  background-color: #ffffff;
  position: relative;
}

.draggable-field:hover {
  border-color: #2196f3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
}

.draggable-field:active {
  cursor: grabbing;
}

.draggable-field.drag-over {
  border-color: #4caf50;
  background-color: #e8f5e8;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.draggable-field.drop-before {
  position: relative;
  border-left: var(--border-width) solid #2196f3;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.6);
}

.draggable-field.drop-after {
  position: relative;
  border-right: var(--border-width) solid #2196f3;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.6);
}

.draggable-field.drop-up {
  position: relative;
  border-top: var(--border-width) solid #2196f3;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.6);
}

.draggable-field.drop-down {
  position: relative;
  border-bottom: var(--border-width) solid #2196f3;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.6);
}


.draggable-field:focus {
  outline: none;
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}



.draggable-field {
  position: relative;
}


/* Estilos para resize handle */
.resize-handle {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 15px;
  height: 15px;
  background-color: #2196f3;
  border-radius: 50%;
  cursor: nw-resize;
  opacity: 0.7;
  transition: opacity 0.3s ease; 
  z-index: 10;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.draggable-field:hover .resize-handle {
  opacity: 1;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.resize-handle:hover {
  background-color: #1976d2;
  transform: scale(1.3);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.resize-handle:active {
  background-color: #0d47a1;
  transform: scale(1.2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
}

/* Estilos para el ícono de resize */
.resize-icon {
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  user-select: none;
}

/* Estilos para campos en modo resize */
.draggable-field.resizing {
  cursor: nw-resize;
  user-select: none;
  background-color: rgb(242, 198, 166);
}

.draggable-field.resizing * {
  pointer-events: none;
}

</style>